export default {
    props: {
        dataTitle: {
            type: [String, Number],
            required: false
        },

        dataImage: {
            type: Object,
            required: false
        },

        dataIcon: {
            type: [String, Number],
            required: false
        },

        dataBorder: {
            type: Boolean,
            default: true
        },

        dataButtonPadding: {
            type: String
        },

        dataButtonGradient: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        title() {
            return this.dataTitle;
        },

        border() {
            return this.dataBorder;
        },

        buttonPadding() {
            return this.dataButtonPadding;
        },

        buttonGradient() {
            return this.dataButtonGradient;
        }
    }
};
